<template>
  <div>
    <div v-if="!setConfigFlag">
      <div class="  mt-4  p-4 bg-white rounded shadow">
        <div style="margin-left: -10px; font-size: 13px !important;">
          <p> <b>PO Direct attainment calculation :</b> </p>
        </div>
        <b-row class="mx-2 my-1">
          <b-form-group class="col">
            <div class="d-flex">
              <b-form-radio value="co_direct_to_po" class="ml-3" v-model="co_to_po_calculation_method">
                Consider course CO direct attainment value only while calculating PO direct
                attainment</b-form-radio>
              <b-form-radio class="ml-3" value="co_final_to_po" v-model="co_to_po_calculation_method">Consider course
                final (Direct & Indirect) CO attainment value while calculating PO
                attainment.</b-form-radio>
            </div>
          </b-form-group>
        </b-row>
      </div>
      <div class="  mt-4  p-4 bg-white rounded shadow">
        <div style="margin-left: -10px; font-size: 13px !important;">
          <p> <b>PO Indirect attainment calculation :</b> </p>
          <p>Set the threshold values to be
            applied for all indirect attainment tools for calculating attainment level:</p>
          <div class="mb-4">
            <b-form-checkbox v-model="attainmentThresholds.equal_thresholds"
              @change="changeInAttainmentToolsEqualThresholds">Apply same threshold for all indirect
              as attainment tools
              (Programme exit survey,Faculty survey,
              Alumni survey
              Employer survey, Parent survey)</b-form-checkbox>
          </div>
          <div v-if="attainmentThresholds.equal_thresholds">
            <!-- same thresholds  -->
            <div>
              <ul>
                <li class="" v-for="(attainment, attainmentIndex) in attainmentThresholds.programme_exit_survey"
                  :key="attainmentIndex">
                  <b-row class="mx-2 my-1">
                    <span class="mr-1" style="align-self: center;"> % of student achieved target
                    </span>
                    <b-form-select class="mr-1" style="width: 60px;" :options="operators"
                      v-model="attainment.comparisan"></b-form-select>
                    <b-form-input class="mr-1" style="width: 60px;" @keypress="handleNumber"
                      v-model="attainment.compare_by"></b-form-input>
                    <span class="mr-1" style="align-self: center;"> then attainment level is </span>
                    <b-form-input class="mr-4" style="width: 60px;" v-model.number="attainment.value"
                      @keypress="handleNumber"></b-form-input>
                    <span style="align-self: center;" class="btn p-0 m-0 text-danger"
                      @click="attainmentThresholds.programme_exit_survey.splice(attainmentIndex, 1)">
                      <i class="fas fa-minus-circle" style="font-size:14px !important;"></i>
                    </span>
                  </b-row>
                </li>
                <li> <b-row class="mx-2 my-1"> <b-link @click="addValue('programme_exit_survey')"> Add
                      Level</b-link></b-row></li>
              </ul>
            </div>
          </div>
          <div v-else>
            <div>
              <h5 style=" font-weight: bold;">Programme exit survey</h5>
              <ul>
                <li class="" v-for="(attainment, attainmentIndex) in attainmentThresholds.programme_exit_survey"
                  :key="attainmentIndex">
                  <b-row class="mx-2 my-1">
                    <span class="mr-1" style="align-self: center;"> % of student achieved target
                    </span>
                    <b-form-select class="mr-1" style="width: 60px;" :options="operators"
                      v-model="attainment.comparisan"></b-form-select>
                    <b-form-input class="mr-1" style="width: 60px;" @keypress="handleNumber"
                      v-model="attainment.compare_by"></b-form-input>
                    <span class="mr-1" style="align-self: center;"> then attainment level is </span>
                    <b-form-input class="mr-4" style="width: 60px;" v-model.number="attainment.value"
                      @keypress="handleNumber"></b-form-input>
                    <span style="align-self: center;" class="btn p-0 m-0 text-danger"
                      @click="attainmentThresholds.programme_exit_survey.splice(attainmentIndex, 1)">
                      <i class="fas fa-minus-circle" style="font-size:14px !important;"></i>
                    </span>
                  </b-row>
                </li>
                <li> <b-row class="mx-2 my-1"> <b-link @click="addValue('programme_exit_survey')"> Add
                      Level</b-link></b-row></li>
              </ul>
            </div>
            <div>
              <h5 style=" font-weight: bold;">Faculty survey</h5>
              <ul>
                <li class="" v-for="(attainment, attainmentIndex) in attainmentThresholds.faculty_survey"
                  :key="attainmentIndex">
                  <b-row class="mx-2 my-1">
                    <span class="mr-1" style="align-self: center;"> % of student achieved target
                    </span>
                    <b-form-select class="mr-1" style="width: 60px;" :options="operators"
                      v-model="attainment.comparisan"></b-form-select>
                    <b-form-input class="mr-1" style="width: 60px;" @keypress="handleNumber"
                      v-model="attainment.compare_by"></b-form-input>
                    <span class="mr-1" style="align-self: center;"> then attainment level is </span>
                    <b-form-input class="mr-4" style="width: 60px;" v-model.number="attainment.value"
                      @keypress="handleNumber"></b-form-input>
                    <span style="align-self: center;" class="btn p-0 m-0 text-danger"
                      @click="attainmentThresholds.faculty_survey.splice(attainmentIndex, 1)">
                      <i class="fas fa-minus-circle" style="font-size:14px !important;"></i>
                    </span>
                  </b-row>
                </li>
                <li> <b-row class="mx-2 my-1"> <b-link @click="addValue('faculty_survey')"> Add
                      Level</b-link></b-row></li>
              </ul>
            </div>
            <div>
              <h5 style="font-weight: bold;">Alumni Survey</h5>
              <ul>
                <li class="" v-for="(attainment, attainmentIndex) in attainmentThresholds.alumini_survey"
                  :key="attainmentIndex">
                  <b-row class="mx-2 my-1">
                    <span class="mr-1" style="align-self: center;"> % of student achieved target
                    </span>
                    <b-form-select class="mr-1" style="width: 60px;" :options="operators"
                      v-model="attainment.comparisan"></b-form-select>
                    <b-form-input class="mr-1" style="width: 60px;" @keypress="handleNumber"
                      v-model="attainment.compare_by"></b-form-input>
                    <span class="mr-1" style="align-self: center;"> then attainment level is </span>
                    <b-form-input class="mr-4" style="width: 60px;" v-model.number="attainment.value"
                      @keypress="handleNumber"></b-form-input>
                    <span style="align-self: center;" class="btn p-0 m-0 text-danger"
                      @click="attainmentThresholds.alumini_survey.splice(attainmentIndex, 1)">
                      <i class="fas fa-minus-circle" style="font-size:14px !important;"></i>
                    </span>
                  </b-row>
                </li>
                <li> <b-row class="mx-2 my-1"> <b-link @click="addValue('alumini_survey')"> Add
                      Level</b-link></b-row></li>
              </ul>
            </div>
            <div>
              <h5 style=" font-weight: bold;">Employer survey</h5>
              <ul>
                <li class="" v-for="(attainment, attainmentIndex) in attainmentThresholds.employer_survey"
                  :key="attainmentIndex">
                  <b-row class="mx-2 my-1">
                    <span class="mr-1" style="align-self: center;"> % of student achieved target
                    </span>
                    <b-form-select class="mr-1" style="width: 60px;" :options="operators"
                      v-model="attainment.comparisan"></b-form-select>
                    <b-form-input class="mr-1" style="width: 60px;" @keypress="handleNumber"
                      v-model="attainment.compare_by"></b-form-input>
                    <span class="mr-1" style="align-self: center;"> then attainment level is </span>
                    <b-form-input class="mr-4" style="width: 60px;" v-model.number="attainment.value"
                      @keypress="handleNumber"></b-form-input>
                    <span style="align-self: center;" class="btn p-0 m-0 text-danger"
                      @click="attainmentThresholds.employer_survey.splice(attainmentIndex, 1)">
                      <i class="fas fa-minus-circle" style="font-size:14px !important;"></i>
                    </span>
                  </b-row>
                </li>
                <li> <b-row class="mx-2 my-1"> <b-link @click="addValue('employer_survey')"> Add
                      Level</b-link></b-row></li>
              </ul>
            </div>
            <div>
              <h5 style=" font-weight: bold;">Parent survey</h5>
              <ul>
                <li class="" v-for="(attainment, attainmentIndex) in attainmentThresholds.parent_survey"
                  :key="attainmentIndex">
                  <b-row class="mx-2 my-1">
                    <span class="mr-1" style="align-self: center;"> % of student achieved target
                    </span>
                    <b-form-select class="mr-1" style="width: 60px;" :options="operators"
                      v-model="attainment.comparisan"></b-form-select>
                    <b-form-input class="mr-1" style="width: 60px;" @keypress="handleNumber"
                      v-model="attainment.compare_by"></b-form-input>
                    <span class="mr-1" style="align-self: center;"> then attainment level is </span>
                    <b-form-input class="mr-4" style="width: 60px;" v-model.number="attainment.value"
                      @keypress="handleNumber"></b-form-input>
                    <span style="align-self: center;" class="btn p-0 m-0 text-danger"
                      @click="attainmentThresholds.parent_survey.splice(attainmentIndex, 1)">
                      <i class="fas fa-minus-circle" style="font-size:14px !important;"></i>
                    </span>
                  </b-row>
                </li>
                <li> <b-row class="mx-2 my-1"> <b-link @click="addValue('parent_survey')"> Add
                      Level</b-link></b-row></li>
              </ul>
            </div>
          </div>
          <p> Enter the % weightage of exit survey & stake holder survey for calculating PO indirect
            attainment</p>
        </div>
        <b-row class="mx-2 my-1">
          <table>
            <tbody>
              <tr>
                <td><span class="mr-1" style="align-self: center;"> Programme exit survey </span></td>
                <td><b-form-input class="mr-1" style="width: 150px;" :max="100" type="number"
                    placeholder="Enter % weightage"
                    v-model="programme_exit_survey_weightage" ref="programme_exit_survey_weightage_input"></b-form-input></td>
              </tr>
              <tr>
                <td><span class="mr-1" style="align-self: center;"> Faculty survey </span></td>
                <td><b-form-input class="mr-1" style="width:150px;" :max="100" type="number"
                    placeholder="Enter % weightage"
                    v-model="faculty_survey_weightage"></b-form-input>
                </td>
              </tr>
              <tr>
                <td><span class="mr-1" style="align-self: center;"> Alumni Survey </span></td>
                <td><b-form-input class="mr-1" style="width: 150px;" :max="100" type="number"
                    placeholder="Enter % weightage"
                    v-model="alumini_survey_weightage"></b-form-input>
                </td>
              </tr>
              <tr>
                <td><span class="mr-1" style="align-self: center;"> Parent Survey </span></td>
                <td><b-form-input class="mr-1" style="width: 150px;" :max="100" type="number"
                    placeholder="Enter % weightage"
                    v-model="parent_survey_weightage"></b-form-input></td>
              </tr>
              <tr>
                <td><span class="mr-1" style="align-self: center;"> Employer Survey </span></td>
                <td><b-form-input class="mr-1" style="width: 150px;" :max="100" type="number"
                    placeholder="Enter % weightage"
                    v-model="employer_survey_weightage"></b-form-input>
                </td>
              </tr>
            </tbody>
          </table>
          <br>
          <span style="color:red" v-if="errorMsgWeightage">{{ errorMsgWeightage }}</span><br>
        </b-row>
      </div>
      <div class="  mt-4  p-4 bg-white rounded shadow">
        <div style="margin-left: -10px; font-size: 13px !important;"><b>Enter the % weightage of PO direct & PO
            indirect
            attainment value for calculating final attainment :</b></div>
        <b-row class="mx-2 my-1">
          <table class="table table-bordered table-striped">
            <thead class="thead-dark text-left">
              <tr>
                <td>Direct method weightage</td>
                <td>Indirect method weightage</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="align-middle">
                  <b-form-input v-model="directmethod_weightage" style="width: 70px" type="number"
                    @blur="checkWeigtage('direct')"></b-form-input>
                </td>
                <td class="align-middle">
                  <b-form-input v-model="indirectmethod_weightage" style="width: 70px" type="number"
                    @blur="checkWeigtage('indirect')"></b-form-input>
                </td>
              </tr>
            </tbody>
          </table>
        </b-row>
      </div>
      <div class="  mt-4  p-4 bg-white rounded shadow">
      </div>
    </div>
    <div v-if="setConfigFlag">confirm<br>
      <div class="  mt-4  p-4 bg-white rounded shadow">
        <div style="margin-left: -10px; font-size: 13px !important;">
          <p> <b>PO Direct attainment calculation : </b><span v-if="co_to_po_calculation_method == 'co_direct_to_po'">
              Consider course CO direct attainment value only while calculating PO direct
              attainment</span>
            <span v-if="co_to_po_calculation_method == 'co_final_to_po'">Consider course
              final (Direct & Indirect) CO attainment value while calculating PO attainment.</span>
          </p>
        </div>
      </div>
      <div class="  mt-4  p-4 bg-white rounded shadow">
        <div style="margin-left: -10px; font-size: 13px !important;">
          <p> <b>PO Indirect attainment calculating :</b> </p>
        </div>
       
        <div v-if="attainmentThresholds.equal_thresholds">
          <!-- same thresholds  -->
          <div>
            <ul>
              <li class="" v-for="(attainment, attainmentIndex) in attainmentThresholds.programme_exit_survey"
                :key="attainmentIndex">
                <b-row class="mx-2 my-1">
                  <span class="mr-1" style="align-self: center;">
                    When the percentage of students achieving the target is {{ attainment.comparisan }} {{ attainment.compare_by }}, the attainment level is {{ attainment.value }}.
                  </span>
                </b-row>
              </li>
            </ul>
          </div>
        </div>
        <div v-else>
          <div>
            <h5 style=" font-weight: bold;">Programme exit survey</h5>
            <ul>
              <li class="" v-for="(attainment, attainmentIndex) in attainmentThresholds.programme_exit_survey"
                :key="attainmentIndex">
                <b-row class="mx-2 my-1">
                  <span class="mr-1" style="align-self: center;">
                    When the percentage of students achieving the target is {{ attainment.comparisan }} {{ attainment.compare_by }}, the attainment level is {{ attainment.value }}.
                  </span>
                </b-row>
              </li>
            </ul>
          </div>
          <div>
            <h5 style=" font-weight: bold;">Faculty survey</h5>
            <ul>
              <li class="" v-for="(attainment, attainmentIndex) in attainmentThresholds.faculty_survey"
                :key="attainmentIndex">
                <b-row class="mx-2 my-1">
                  <span class="mr-1" style="align-self: center;">
                    When the percentage of students achieving the target is {{ attainment.comparisan }} {{ attainment.compare_by }}, the attainment level is {{ attainment.value }}.
                  </span>
                </b-row>
              </li>
            </ul>
          </div>
          <div>
            <h5 style="font-weight: bold;">Alumini Survey</h5>
            <ul>
              <li class="" v-for="(attainment, attainmentIndex) in attainmentThresholds.alumini_survey"
                :key="attainmentIndex">
                <b-row class="mx-2 my-1">
                  <span class="mr-1" style="align-self: center;">
                    When the percentage of students achieving the target is {{ attainment.comparisan }} {{ attainment.compare_by }}, the attainment level is {{ attainment.value }}.
                  </span>
                </b-row>
              </li>
            </ul>
          </div>
          <div>
            <h5 style=" font-weight: bold;">Employer survey</h5>
            <ul>
              <li class="" v-for="(attainment, attainmentIndex) in attainmentThresholds.employer_survey"
                :key="attainmentIndex">
                <b-row class="mx-2 my-1">
                  <span class="mr-1" style="align-self: center;">
                    When the percentage of students achieving the target is {{ attainment.comparisan }} {{ attainment.compare_by }}, the attainment level is {{ attainment.value }}.
                  </span>
                </b-row>
              </li>
            </ul>
          </div>
          <div>
            <h5 style=" font-weight: bold;">Parent survey</h5>
            <ul>
              <li class="" v-for="(attainment, attainmentIndex) in attainmentThresholds.parent_survey"
                :key="attainmentIndex">
                <b-row class="mx-2 my-1">
                  <span class="mr-1" style="align-self: center;">
                    When the percentage of students achieving the target is {{ attainment.comparisan }} {{ attainment.compare_by }}, the attainment level is {{ attainment.value }}.
                  </span>
                </b-row>
              </li>
            </ul>
          </div>
        </div>
        <br>
        <p>% weightage of exit survey & stake holder survey for calculating PO indirect attainment</p>
        <b-row class="mx-2 my-1">
          <table>
            <tbody>
              <tr>
                <td><span class="mr-1" style="align-self: center;"> Programme exit survey - % weightage
                  </span></td>
                <td>
                  <span class="mr-1" style="align-self: center;">
                    {{ programme_exit_survey_weightage }}</span>
                </td>
              </tr>
              <tr>
                <td><span class="mr-1" style="align-self: center;"> Faculty survey - % weightage </span>
                </td>
                <td><span class="mr-1" style="align-self: center;"> {{ faculty_survey_weightage
                    }}</span>
                </td>
              </tr>
              <tr>
                <td><span class="mr-1" style="align-self: center;"> Alumini Survey - % weightage </span>
                </td>
                <td>
                  <span class="mr-1" style="align-self: center;"> {{ alumini_survey_weightage
                    }}</span>
                </td>
              </tr>
              <tr>
                <td><span class="mr-1" style="align-self: center;"> Parent Survey - % weightage </span>
                </td>
                <td><span class="mr-1" style="align-self: center;"> {{ parent_survey_weightage }}</span>
                </td>
              </tr>
              <tr>
                <td><span class="mr-1" style="align-self: center;"> Employer Survey - % weightage
                  </span></td>
                <td><span class="mr-1" style="align-self: center;"> {{ employer_survey_weightage
                    }}</span>
                </td>
              </tr>

            </tbody>
          </table>
        </b-row>
      </div>
      <div class="  mt-4  p-4 bg-white rounded shadow">
        <div style="margin-left: -10px; font-size: 13px !important;"><b>Enter the % weightage of PO direct & PO
            indirect
            attainment value for calculating final attainment :</b></div>
        <b-row class="mx-2 my-1">
          <table class="table table-bordered table-striped">
            <thead class="thead-dark text-left">
              <tr>
                <td>Direct method weightage</td>
                <td>Indirect method weightage</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="align-middle">
                  {{ directmethod_weightage }}
                </td>
                <td class="align-middle">
                  {{ indirectmethod_weightage }}
                </td>
              </tr>
            </tbody>
          </table>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["usersubgroupid"],
  async created() {
    this.fetchData = true;
    await this.getConfig();
    this.fetchData = false;
  },
  data() {
    return {
      getConfigFlag: true,
      errorMsgWeightage: '',
      attainmentThresholds: {
        equal_thresholds: true,
        programme_exit_survey: [
          { value: 1, comparisan: '>=', compare_by: 50 },
          { value: 2, comparisan: '>', compare_by: 65 },
          { value: 3, comparisan: '>', compare_by: 80 },
        ],
        faculty_survey: [
          { value: 1, comparisan: '>=', compare_by: 50 },
          { value: 2, comparisan: '>', compare_by: 65 },
          { value: 3, comparisan: '>', compare_by: 80 },
        ],
        alumini_survey: [
          { value: 1, comparisan: '>=', compare_by: 50 },
          { value: 2, comparisan: '>', compare_by: 65 },
          { value: 3, comparisan: '>', compare_by: 80 },
        ],
        employer_survey: [
          { value: 1, comparisan: '>=', compare_by: 50 },
          { value: 2, comparisan: '>', compare_by: 65 },
          { value: 3, comparisan: '>', compare_by: 80 },
        ],
        parent_survey: [
          { value: 1, comparisan: '>=', compare_by: 50 },
          { value: 2, comparisan: '>', compare_by: 65 },
          { value: 3, comparisan: '>', compare_by: 80 },
        ],
      },
      operators: [
        { value: null, text: "Select Operator" },
        { value: "<", text: "<" },
        { value: ">", text: ">" },
        { value: "<=", text: "<=" },
        { value: ">=", text: ">=" },
      ],
      setConfigFlag: false,
      getDataFlag: false,
      getReportFlag: false,
      fetchData: false,
      directmethod_weightage: '',
      indirectmethod_weightage: '',
      co_to_po_calculation_method: null,
      programme_exit_survey_weightage: null,
      faculty_survey_weightage: null,
      alumini_survey_weightage: null,
      parent_survey_weightage: null,
      employer_survey_weightage: null
    };
  },
  methods: {
    addValue(tool) {
      if (!this.attainmentThresholds[tool]) {
        this.$bvToast.toast(`Invalid key: ${tool}`, {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
        return;
      }

      this.attainmentThresholds[tool].push({
        value: "",
        comparisan: null,
        compare_by: "",
      });
    },

    handleNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },
    changeInAttainmentToolsEqualThresholds() {
      if (!this.attainmentThresholds.equal_thresholds) {
        this.attainmentThresholds.faculty_survey = [
          { value: 1, comparisan: '>=', compare_by: 50 },
          { value: 2, comparisan: '>', compare_by: 65 },
          { value: 3, comparisan: '>', compare_by: 80 },
        ];
        this.attainmentThresholds.alumini_survey = [
          { value: 1, comparisan: '>=', compare_by: 50 },
          { value: 2, comparisan: '>', compare_by: 65 },
          { value: 3, comparisan: '>', compare_by: 80 },
        ];
        this.attainmentThresholds.employer_survey = [
          { value: 1, comparisan: '>=', compare_by: 50 },
          { value: 2, comparisan: '>', compare_by: 65 },
          { value: 3, comparisan: '>', compare_by: 80 },
        ];
        this.attainmentThresholds.parent_survey = [
          { value: 1, comparisan: '>=', compare_by: 50 },
          { value: 2, comparisan: '>', compare_by: 65 },
          { value: 3, comparisan: '>', compare_by: 80 },
        ];
      }
    },
    checkWeigtage(input) {
      if (
        Number(this.directmethod_weightage) +
        Number(this.indirectmethod_weightage) !=
        100
      ) {
        if (
          Number(this.directmethod_weightage) > 100 ||
          Number(this.indirectmethod_weightage) > 100
        ) {
          this.$toast.error(
            "The sum of direct indirect weightage should be equal to 100",
            {
              position: "top",
              durartion: 3000,
            }
          );
          this.directmethod_weightage = 0;
          this.indirectmethod_weightage = 0;
          return;
        }
        if (input == "direct") {
          this.indirectmethod_weightage =
            100 - Number(this.directmethod_weightage);
        } else {
          this.directmethod_weightage =
            100 - Number(this.indirectmethod_weightage);
        }
      }
    },
    proceedNextCheck() {
      this.errorMsgWeightage = "";

      let totalWeightage = Number(this.employer_survey_weightage) +
        Number(this.parent_survey_weightage) +
        Number(this.alumini_survey_weightage) +
        Number(this.faculty_survey_weightage) +
        Number(this.programme_exit_survey_weightage);

      if (totalWeightage !== 100) {
        this.$toast.error("The sum of % weightage of exit survey & stake holder survey should be equal to 100", {
          position: "top",
          duration: 4000,
        });
        this.errorMsgWeightage = "The sum of % weightage of exit survey & stake holder survey should be equal to 100";

        this.$nextTick(() => {
          if (this.$refs.programme_exit_survey_weightage_input) {
            this.$refs.programme_exit_survey_weightage_input.focus();
          }
        });
        return false;
      }
      return true;
    },
    async getConfig() {
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/poattainment/getconfig`;
      this.$axios
        .post(url, {
          subgroup: this.usersubgroupid,
          step: "configure",
        })
        .then((response) => {
          this.co_to_po_calculation_method = response.data.co_to_po_calculation_method;
          this.programme_exit_survey_weightage = response.data.programme_exit_survey_weightage;
          this.faculty_survey_weightage = response.data.faculty_survey_weightage;
          this.alumini_survey_weightage = response.data.alumini_survey_weightage;
          this.parent_survey_weightage = response.data.parent_survey_weightage;
          this.employer_survey_weightage = response.data.employer_survey_weightage;
          this.directmethod_weightage = response.data.directmethod_weightage;
          this.indirectmethod_weightage = response.data.indirectmethod_weightage;
          this.attainmentThresholds = response.data.indirect_tools_attainment_thresholds ?
            response.data.indirect_tools_attainment_thresholds : this.attainmentThresholds;
        })
        .catch((error) => {
          this.$toast.error(error.response.data.message, {
            position: "top",
            duration: 3000,
          });
        });
    },
    async setConfig() {
      this.fetchData = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/poattainment/setconfig`;
      await this.$axios
        .post(url, {
          subgroup: this.usersubgroupid,
          step: "configure",
          co_to_po_calculation_method: this.co_to_po_calculation_method,
          programme_exit_survey_weightage: this.programme_exit_survey_weightage,
          faculty_survey_weightage: this.faculty_survey_weightage,
          alumini_survey_weightage: this.alumini_survey_weightage,
          parent_survey_weightage: this.parent_survey_weightage,
          employer_survey_weightage: this.employer_survey_weightage,
          directmethod_weightage: this.directmethod_weightage,
          indirectmethod_weightage: this.indirectmethod_weightage,
          indirect_tools_attainment_thresholds: this.attainmentThresholds,
        })
        .then((response) => {
          response;
          this.setConfigFlag = true;
          this.getDataFlag = true;
          this.getReportFlag = true;
        })
        .catch((error) => {
          this.$toast.error(error.response.data.message, {
            position: "top",
            duration: 3000,
          });
        });
    },
  },
};
</script>